module.exports = __webpack_public_path__ + "static/media/game-background-home.27466ebc.jpg";